// WAENN — Filtros custom de Color y Talla (drawer "Filtrar").
// Talla y Color no estan habilitados como "standard filters" nativos de
// Shopify (eso requiere configuracion manual en Admin > Search & Discovery),
// asi que se resuelven en cliente: cada tarjeta del grid lleva atributos
// data-waenn-colors / data-waenn-sizes (renderizados en
// main-collection-product-grid.liquid a partir de las opciones reales del
// producto) y aqui se muestran/ocultan segun los checkboxes marcados en el
// drawer. Multiples valores dentro del mismo grupo = OR; entre grupos = AND.
//
// Color usa grupos de alias: cada checkbox de swatch representa un color
// "oficial" de WAENN (p.ej. "Marron") pero su value real es una lista
// separada por comas con TODOS los valores crudos de Shopify que caen bajo
// ese tono (p.ej. "MARRON,BROWN"). Un producto hace match si alguno de sus
// colores crudos (data-waenn-colors) aparece en ALGUNO de los grupos
// marcados, comparando siempre en mayusculas para ignorar diferencias de
// capitalizacion entre variantes.
//
// Nota importante: NO se oculta tocando el className o el style inline del
// <li>, porque el sistema de animaciones scroll-reveal de Dawn (scroll-
// trigger / data-cascade) reescribe periodicamente esos mismos atributos en
// esos mismos elementos al entrar/salir del viewport, deshaciendo cualquier
// cambio que hagamos ahi (tanto style.display como classList). En su lugar
// se inyecta una hoja de estilo <style> propia con selectores nth-child,
// que Dawn nunca toca.

(function () {
  function waennSelectedValues(selector) {
    return Array.prototype.slice
      .call(document.querySelectorAll(selector + ':checked'))
      .map(function (el) {
        return el.value;
      });
  }

  function waennSelectedColorGroups() {
    return Array.prototype.slice
      .call(document.querySelectorAll('.waenn-color-checkbox:checked'))
      .map(function (el) {
        return el.value.split(',').map(function (v) {
          return v.trim().toUpperCase();
        });
      });
  }

  function waennSetCountText(count) {
    var label = count + (count === 1 ? ' producto' : ' productos');
    var nodes = document.querySelectorAll(
      '#ProductCount, .mobile-facets__count, #ProductCountDesktop'
    );
    nodes.forEach(function (node) {
      node.textContent = label;
    });
  }

  function waennGetStyleTag() {
    var style = document.getElementById('waenn-custom-filter-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'waenn-custom-filter-style';
      document.head.appendChild(style);
    }
    return style;
  }

  function waennApplyCustomFilters() {
    var grid = document.querySelector('#product-grid');
    if (!grid) return;

    var selectedColorGroups = waennSelectedColorGroups();
    var selectedSizes = waennSelectedValues('.waenn-size-checkbox');
    var items = Array.prototype.slice.call(grid.children);
    var visibleCount = 0;
    var hiddenSelectors = [];

    items.forEach(function (li, index) {
      var colors = (li.getAttribute('data-waenn-colors') || '')
        .split('|')
        .filter(Boolean)
        .map(function (c) {
          return c.trim().toUpperCase();
        });
      var sizes = (li.getAttribute('data-waenn-sizes') || '')
        .split('|')
        .filter(Boolean);

      var colorMatch =
        selectedColorGroups.length === 0 ||
        colors.length === 0 ||
        colors.some(function (c) {
          return selectedColorGroups.some(function (group) {
            return group.indexOf(c) !== -1;
          });
        });

      var sizeMatch =
        selectedSizes.length === 0 ||
        sizes.length === 0 ||
        sizes.some(function (s) {
          return selectedSizes.indexOf(s) !== -1;
        });

      var match = colorMatch && sizeMatch;
      if (match) {
        visibleCount += 1;
      } else {
        hiddenSelectors.push(
          '#product-grid > .grid__item:nth-child(' + (index + 1) + ')'
        );
      }
    });

    var style = waennGetStyleTag();
    style.textContent = hiddenSelectors.length
      ? hiddenSelectors.join(',\n') + ' { display: none !important; }'
      : '';

    waennSetCountText(visibleCount);
    // Algo en el tema (fuera de nuestro control) reescribe el texto del
    // contador justo despues del evento 'change'. Lo reafirmamos un
    // instante mas tarde para que la cifra mostrada sea siempre la real.
    setTimeout(function () {
      waennSetCountText(visibleCount);
    }, 60);
    setTimeout(function () {
      waennSetCountText(visibleCount);
    }, 250);
  }

  // Capture phase: intercepta el cambio ANTES de que facets.js (Dawn) lo vea
  // en fase de burbuja, para que no intente disparar un fetch de filtros
  // nativo con parametros que Shopify no reconoce.
  document.addEventListener(
    'change',
    function (e) {
      var target = e.target;
      if (
        target &&
        (target.classList.contains('waenn-color-checkbox') ||
          target.classList.contains('waenn-size-checkbox'))
      ) {
        e.stopPropagation();
        waennApplyCustomFilters();
      }
    },
    true
  );
})();
